import { toast } from 'react-toastify';

// eslint-disable-next-line default-param-last -- FIXME
export const apiErrorToast = (translationKey = '', error) => {
  if (error?.response?.data?.['hydra:description']) {
    return toast.error(
      `${translationKey} ${error.response.data['hydra:description']}`
    );
  }
  return toast.error(translationKey);
};
